/* eslint-disable no-unused-vars */
import { useContext } from 'react';
import { AgGrid2 } from 'components';
import { ManageCampaignsContext } from 'contexts';

const showAlert = (rowData) => {
  if (rowData !== null && !rowData?.length) return true;
  return false;
};

export const CampaignDisplayList = () => {
  const { campaignData$, filteredCamp, rowData, colDefs } = useContext(ManageCampaignsContext);

  if (showAlert(rowData)) {
    return (
      <p
        style={{
          height: '355px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderTop: '1px solid #E2E8F0',
        }}
      >
        No records to display
      </p>
    );
  }
  if (rowData?.length && colDefs?.length) {
    return <AgGrid2 filteredCamp={filteredCamp} />;
  }
  return null;
};
